import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Bill/Main";
import Form from "./Bill/Form";

// Utils
import {
  getDataWithComp,
  getMaxDocNo,
  getAlert,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";

const Bill = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxBiNo, setMaxBiNo] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_1301_BL_H",
        `ORDER BY Doc_No DESC`
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      // หาค่าสูงของ DocNo ใน BL_H สำหรับ BI (ใบวางบิล)
      const maxBi = getMaxDocNo(masterList, "BI");
      setMaxBiNo(maxBi);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onPageUpdate = (docNo) => {
    setMaxBiNo(docNo);
    setMode("U");
  };

  return (
    <div>
      <div className="Invoice">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="btn btn-toggle-sidebar"
          style={{
            position: "fixed",
            top: "1rem",
            left: isSidebarOpen ? "190px" : "-15px",
            zIndex: 1001,
            background: "transparent",
            border: "none",
            color: "#EF6C00",
            fontSize: "20px",
          }}
        >
          {isSidebarOpen ? "✖" : "☰"}
        </button>
        <div className="wrapper">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
          <div
            className={`main-panel ${
              isSidebarOpen ? "sidebar-open" : "sidebar-closed"
            }`}
          >
            <div className="container">
              <div className="page-inner">
                {mode === "S" ? (
                  <Main
                    name={"ใบวางบิล"}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    name={"ใบวางบิล"}
                    docNo={maxBiNo}
                    getReport={getReport}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bill;
